import { Box } from "../../components";

export const GridBreak = () => {
  return <Box width="100%"></Box>;
};
